/**
 * Module definition for reports module. The reports module manages
 * the application's top-level reports view (i.e., /reports).
 *
 * @module routes.reports
 */

angular.module('routes.reports', [
  'stack',
  'routes.reports.constants',
  'routes.reports.ReportsController',
  'routes.reports.ReportsPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.reports', {
          url: '/reports/:reportId',
          templateUrl: 'routes/reports/reports.html',
          controller: 'ReportsController',
          params: {
            reportId: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'REPORTS',
              function (ConstantResolver, REPORTS) {
                return new ConstantResolver(REPORTS);
              }
            ],
            reportsPayload: [
              'ReportsPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (ReportsPayloadResolver, $stateParams, newmanPayload) {
                return new ReportsPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
